import { render } from "./GoodsSection.vue?vue&type=template&id=4f79f8d8&scoped=true"
import script from "./GoodsSection.vue?vue&type=script&lang=js"
export * from "./GoodsSection.vue?vue&type=script&lang=js"

import "./GoodsSection.vue?vue&type=style&index=0&id=4f79f8d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f79f8d8"]])

export default __exports__